// extracted by mini-css-extract-plugin
module.exports = {"defaultRenderingContentResolver":"DefaultRenderingContentResolver_defaultRenderingContentResolver__FIRQ_"};